<div>
  <ng-ui-kit-footer
    [simple]="true"
    [footerLeftLabel]="'FOOTER.TITLE' | translate"
    [footerPostList]="this.footerPostList$ | async">
  </ng-ui-kit-footer>
</div>
